/** 게이트웨이 기준 Glow API. 로컬은 '/glow' (vite 프록시), 개발계는 https://api-dev.boostree.partners/glow */
export const GLOW_API_URL = import.meta.env.VITE_GLOW_API_BASE_URL || '/glow';

export const SOCKET_BASE_URL =
  import.meta.env.VITE_SOCKET_WEBSOCKET_BASE_URL || '';

export const HEADER = {
  LOCALE: 'X-Glow-Locale',
  CURRENCY: 'X-Glow-Currency',
  GUEST: 'X-Glow-Guest',
  IDEMPOTENCY_KEY: 'Idempotency-Key',
} as const;

export const AUTH_REFRESH_PATH = '/app/v1/auth/refresh';
